"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonGroup = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _button = _interopRequireDefault(require("../../atoms/button"));

var _tokens = require("../../../tokens");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n\n  ", " {\n    ", ": ", ";\n\n    &: ", " {\n      margin: 0;\n    }\n  }\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ":first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  ", ":last-child {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  ", ":not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var justifyContent = {
  left: 'flex-start',
  right: 'flex-end'
};
var groupRadiusStyles = (0, _styledComponents.css)(_templateObject(), _button["default"].Element, _button["default"].Element, _button["default"].Element);

var StyledButtonGroup = _styledComponents["default"].div(_templateObject2(), function (props) {
  return justifyContent[props.align];
}, _button["default"].Element, function (props) {
  return props.align === 'left' ? 'margin-right' : 'margin-left';
}, function (props) {
  return props.compressed ? 0 : _tokens.spacing.xsmall;
}, function (props) {
  return props.align === 'left' ? 'last-child' : 'first-child';
}, function (props) {
  return props.compressed ? groupRadiusStyles : null;
});

exports.StyledButtonGroup = StyledButtonGroup;

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react["default"].createElement(StyledButtonGroup, props, children);
};

ButtonGroup.propTypes = {
  align: _propTypes["default"].oneOf(['left', 'right']),
  compressed: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)])
};
ButtonGroup.defaultProps = {
  compressed: false,
  align: 'left'
};
var _default = ButtonGroup;
exports["default"] = _default;